export default __webpack_public_path__ + "static/media/calendar.efff95a3.svg";